module.exports = "<div #baChartistChart class=\"ba-chartist-chart {{baChartistChartClass || ''}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baChartistChart/baChartistChart.html
// module id = ../../../../../src/app/theme/components/baChartistChart/baChartistChart.html
// module chunks = main